/**
 * DownloadImageUseCase
 * Use case for downloading a file from a GCS bucket URL into an in-memory File object.
 * Requires CORS to be configured on the target bucket (gsutil cors set).
 */

import { cloudStorageService } from '@/data/storage/remote/cloudStorageService';

export class DownloadImageUseCase {
  /**
   * Download an image from a direct GCS URL and return it as a File.
   *
   * @param url - Full GCS URL (e.g. `${env.CDN_BUCKET_PREFIX}media/...` or `${env.USER_PROFILES_BUCKET_PREFIX}id/id`)
   * @param fileName - Desired file name for the resulting File object
   * @returns File if the download succeeded, null otherwise
   */
  async execute(url: string, fileName: string): Promise<File | null> {
    const blob = await cloudStorageService.downloadFile(url);
    if (!blob) return null;
    return new File([blob], fileName, { type: blob.type });
  }
}

export const downloadImageUseCase = new DownloadImageUseCase();
